<template>
  <div class="comp">
    <el-dialog
      :visible.sync="dialog_state"
      :width="hasGiftCard ? '1060px' : '520px'"
      @close="submit('close')"
      :top="'15vh'"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <div class="titleLine">
          <span class="title">结账</span>
          <span class="total">
            本单合计：{{ order.total_price }}元
            <span v-if="mustYue !== 0" style="color: red; font-size: 12px"
              >( 余额不低于：{{ mustYue }}元 )</span
            >
            <el-tooltip
              v-if="mustYue !== 0"
              style="margin-left: 2px"
              effect="dark"
              :content="
                '本单使用了会员折扣活动，支付的金额中，余额不能少于' +
                mustYue +
                '元'
              "
              placement="bottom"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span
              v-if="
               ( order.order_type_id === 1 ||
                order.order_type_id === 2 ||
                order.order_type_id === 3 ||
                order.order_type_id === 6 ||
                type === 'mergeOrder')&&giftCardNumMax>0
              "
              style="color: red; font-size: 12px"
              >( 现金卡不大于：{{ giftCardNumMax }}元 )</span
            >
            <span v-if="isShow&&meituan" style="color: red; font-size: 12px"
              >(只能使用电商支付：{{ meituan }}元 )</span
            >
            <span
              v-if="order.order_type_id === 8&&giftCardNumMax>0"
              style="color: red; font-size: 12px"
              >( 活体卡不大于：{{ giftCardNumMax }}元 )</span
            >
          </span>
          <!-- <span class="count">商品总数：2件</span> -->
        </div>
      </div>
      <div class="dialog" style="width: 480px; display: inline-block">
        <div class="content">
          <div class="line" v-if="type === 'tailMoney'||type === 'tailMoneyMergeOrder'">
            <div class="label">订金：</div>
            <el-input
              class="input"
              v-model="dingjin"
              disabled
              placeholder="0.00"
            ></el-input>
          </div>
          <div class="line">
            <div class="label">现金支付：</div>
            <el-input
              class="input"
              v-model="xianjin"
              @focus="focusXianjin"
              placeholder="0.00"
            ></el-input>
            <div style="display: flex">
              <div
                v-if="canYue && memberDetail.frozen === false"
                class="label"
              >
                余额支付：
              </div>
              <el-input
                v-if="canYue && memberDetail.frozen === false"
                class="input"
                v-model="yue"
                @focus="focusYue"
                placeholder="0.00"
              ></el-input>
            </div>
          </div>
          <!-- <div class="line">
						<div class="label">微信支付：</div>
						<el-input class="input" v-model="weixin" @focus="focusWeixin" placeholder="0.00"></el-input>
						<div class="label">支付宝支付：</div>
						<el-input class="input" v-model="zhifubao" @focus="focusZhifubao" placeholder="0.00"></el-input>
          </div>-->
          <div class="line">
            <div class="label">电商平台：</div>
            <el-input
              class="input"
              :disabled="
                !($buttonAuthority('mendian-dianshang') ||
                order.order_type_id == 5 ||
                order.order_type_id == 3 ||
                order.order_type_id == 4 ||
                order.order_type_id == 7)
              "
              v-model="meituan"
              @focus="focusMeituan"
              placeholder="0.00"
            ></el-input>
            <div class="label">优惠支付：</div>
            <el-input
              class="input"
              v-model="youhui"
              @focus="focusYouhui"
              :disabled="isDisabled"
              placeholder="0.00"
            ></el-input>
          </div>
          <div class="line">
            <!-- <div class="label">嘉联支付：</div>
            <el-input
              class="input"
              v-model="jialian"
              @focus="focusJialian"
              :disabled="shopId != '5e9412e0b2bfbc089daerr13'"
              placeholder="0.00"
            ></el-input> -->
            <div class="label">京东支付：</div>
            <el-input
              @blur="jingdongPay"
              @input="jingdongPay"
              class="input"
              v-model="jingdong"
              @focus="focusJingdong"
              placeholder="0.00"
              :disabled="isDisabled"
            ></el-input>
            <div class="label">拉卡拉支付：</div>
            <el-input
              @input="lakalaPay"
              @change="lakalaPay"
              @blur="lakalaPay"
              class="input"
              v-model="lakala"
              @focus="focusLakala"
              placeholder="0.00"
              :disabled="isDisabled"
            ></el-input>
          </div>
          <div class="line">
            <div class="label">POS支付：</div>
            <el-input
              class="input"
              v-model="pos"
              @focus="focusPos"
              placeholder="0.00"
              :disabled="isDisabled"
            ></el-input>
            <!-- <div class="label">嘉联支付：</div>
						<el-input class="input" v-model="jialian" @focus="focusJialian"
							:disabled="shopId != '5e9412e0b2bfbc089daerr13'" placeholder="0.00"></el-input> -->
            <!--可用订单类型： 商品 病例 洗美 寄养 活体-->
            <div
              style="display: flex"
              v-if="
                order.order_type_id === 1 ||
                order.order_type_id === 2 ||
                order.order_type_id === 3 ||
                order.order_type_id === 6 ||
                order.order_type_id === 8 ||
                type === 'mergeOrder'
              "
            >
              <div class="label">礼品卡支付：</div>
              <div v-if="type === 'changePayInfo'">
                <el-input
                  class="input"
                  v-model="giftCard"
                  disabled
                  placeholder="0.00"
                ></el-input>
              </div>
              <div v-else>
                <el-input
                  class="input"
                  v-if="hasGiftCard"
                  v-model="giftCard"
                  @focus="focusGiftCard"
                  @input="calcGiftCardNum"
                  placeholder="0.00"
                ></el-input>
                <div
                  v-else
                  style="
                    font-size: 14px;
                    line-height: 38px;
                    color: rgb(64, 158, 255);
                    cursor: pointer;
                  "
                  @click="focusGiftCard"
                >
                  使用
                </div>
              </div>
            </div>
          </div>
          <div class="line">
            <div v-if="order.order_type_id === 6" class="label">押金支付：</div>
            <el-input
              v-if="order.order_type_id === 6"
              class="input"
              v-model="deposit"
              @focus="focusDeposit"
              placeholder="0.00"
            ></el-input>
            <div class="label">找零：</div>
            <div class="price">￥{{ zhaoling }}</div>
          </div>
          <!-- <div class="line">
						<div class="label">找零：</div>
						<div class="price">￥{{zhaoling}}</div>
          </div>-->
          <div class="line">
            <div class="label">备注：</div>
            <el-input
              style="width: 335px"
              type="textarea"
              class="input"
              v-model="beizhu"
              placeholder="请输入备注..."
            ></el-input>
          </div>
          <div class="line" style="margin-top: 40px">
            <div class="label" style="font-size: 14px">可用余额：</div>
            <div class="price" style="font-size: 14px">
              ￥{{
                memberDetail.userBalance &&
                memberDetail.userBalance.toFixed(2)
              }}{{ memberDetail.frozen === true ? "(锁)" : "" }}
            </div>
            <div class="label" style="font-size: 14px">可用押金：</div>
            <div class="price" style="font-size: 14px">
              ￥{{
                memberDetail.userDeposit &&
                memberDetail.userDeposit.toFixed(2)
              }}
            </div>
          </div>
        </div>
        <div class="btns">
          <el-button
            class="submit"
            :class="jingdongState == 0 ? 'active' : 'activeA'"
            v-if="
              mustYue === 0 && order.total_price > 0 && type !== 'returnGoods'
            "
            @click="submit('scan')"
            :disabled="jingdongDisabled"
          >
            京东扫码支付
          </el-button>
          <el-button
            v-if="order.total_price > 0 && type !== 'returnGoods'"
            :class="lakalaState == 0 ? 'active' : 'activeA'"
            class="submit"
            :disabled="lakalaDisabled"
            @click="submit('lakalaScan')"
          >
            拉卡拉扫码支付
          </el-button>
          <!-- <div
            class="submit"
            v-if="
              mustYue === 0 && order.total_price > 0 && type !== 'returnGoods'
            "
            v-show="shopId === '5e9412e0b2bfbc089daerr13'"
            style="background-color: #1853a4; color: #ffffff"
            @click="submit('jialianScan')"
          >
            嘉联扫码支付
          </div> -->
          <div
            class="submit btn3"
            @click="submit('submit')"
            style="cursor: pointer"
          >
            结算
          </div>
        </div>
        <div class="packet">结算之后自动打印小票</div>
      </div>
      <div
        v-if="hasGiftCard"
        style="
          width: 520px;
          display: inline-block;
          height: 490px;
          vertical-align: top;
          padding: 0 0 20px 20px;
          box-sizing: border-box;
          margin-left: 20px;
          border-left: 1px solid #ccc;
        "
      >
        <div style="padding-bottom: 10px">
          <label style="font-size: 12px; margin-right: 10px" slot="label"
            >录入礼品卡号</label
          >
          <el-input
            style="width: 180px"
            v-model="scanningCode"
            @keyup.enter.native="getGiftCardDetail"
            placeholder="请录入礼品卡号"
            size="small"
          ></el-input>
        </div>
        <div>
          <div
            v-for="(item, index) in giftCardTableData"
            :key="index"
            class="giftCardItem"
            style="position: relative"
          >
            <img
              src="../assets/img/cha.png"
              style="
                width: 20px;
                height: 20px;
                position: absolute;
                top: -10px;
                right: -10px;
                cursor: pointer;
              "
              @click="closeGiftCard(index)"
            />
            <div class="giftCardItemLine">
              <span>名称：{{ item.card_name }}</span>
              <span>卡号：{{ item.card_number }}</span>
              <span>面额：{{ item.price }}</span>
            </div>
            <div class="giftCardItemLine">
              <span>余额：{{ item.surplus_money }}</span>
              <span>本次使用：{{ item.useNum }}</span>
              <span
                >剩余金额：{{
                  $public.jian(item.surplus_money, item.useNum)
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <div v-if="dialogScanState">
      <dialogScan
        :orderType="type"
        :payInfo="pay_Info"
        :orderID="order._id"
        :orderNum="order.no"
        :payType="pay_type"
        @submit="submitScan"
      ></dialogScan>
    </div>
    <div v-if="dialogScanJialianState">
      <dialogScanJialian
        :orderType="type"
        :orderNum="order.no"
        @submit="submitJialianScan"
      ></dialogScanJialian>
    </div>
    <!-- <iframe v-if="printUrl" :src="'ChuLinPrint:'+printUrl" width="0" height="0"></iframe> -->
  </div>
</template>
<script>
// 充值 消费 退货 换货
// 发票:充值和消费有发票
// props orderId:订单号
// type:订单类型（order, tailMoney(活体付尾款), changePayInfo(修改支付方式),
// recharge, yajin，exchangeGoods，returnGoods，mergeOrder）

import del from "@/util/del.js";
import dialogScan from "./dialog_scan.vue";
import dialogScanJialian from "./dialog_scan_jialian.vue";
import printJs from "../util/print.js";
export default {
  components: {
    dialogScan,
    dialogScanJialian,
  },
  props: {
    orderId: {
      default: "",
    },
    type: {
      default: "order",
    },
    canYue: {
      default: true,
    },
  },
  data() {
    return {
      // 按钮颜色
      lakalaState: 0,
      jingdongState: 0,
      // 禁用
      jingdongDisabled: true,
      lakalaDisabled: true,
      isDisabled: false,
      isShow: false,
      hasGiftCard: false,
      memberDetail: {
      },
      mustYue: 0, // 必须使用的余额数
      mustThird: 0, //必须使用第三方
      // printUrl:'',
      dialog_state: true,
      xianjin: "",
      yue: "",
      weixin: "",
      zhifubao: "",
      meituan: "",
      youhui: "",
      jingdong: "",
      lakala: "", //拉卡拉
      jialian: "",
      giftCard: "",
      pos: "",
      dingjin: "", // 活体订金
      deposit: "",
      beizhu: "",

      order: "",

      o: null,

      dialogScanState: false,
      dialogScanJialianState: false,

      // 礼品卡
      scanningCode: "",
      giftCardTableData: [],
      giftCardNumMax: 0,
      // pay_type 1京东 2拉卡拉
      pay_type: "",
      pay_Info: null,
    };
  },
  computed: {
    shopId() {
      return this.$store.state.shopId;
    },
    allMoney() {
      let a = this.$public.toDoubleFixed2(
        Number(this.xianjin || 0) +
          Number(this.yue || 0) +
          Number(this.weixin || 0) +
          Number(this.zhifubao || 0) +
          Number(this.meituan || 0) +
          Number(this.youhui || 0) +
          Number(this.giftCard || 0) +
          Number(this.jingdong || 0) +
          Number(this.lakala || 0) +
          Number(this.pos || 0) +
          // + Math.abs(Number(this.deposit))
          Number(this.deposit) +
          Number(this.dingjin || 0) // // 活体订金
      );
      return a;
    },
    zhaoling() {
      if (this.allMoney > this.order.total_price) {
        return this.$public.toDoubleFixed2(
          this.allMoney - this.order.total_price
        );
      } else {
        return 0;
      }
    },
    needPay() {
      if (this.order.total_price - this.allMoney > 0) {
        return this.$public.toDoubleFixed2(
          this.order.total_price - this.allMoney
        );
      } else {
        return "";
      }
    },
  },

  mounted() {
    console.log("类型", this.type,this.orderId);
    this.o = new del();
    this.getOrderDetail();
  },
  methods: {
    // 打印发票
    getInvoice() {
      if (this.type == "order" || this.type == "tailMoney") {
        this.$http
          .get("/api/Order/OrderReceipt", {
            orderNumber: this.orderId,
          })
          .then((res) => {
            if (res.code == 0) {
              let d = res.data;
              printJs.printTicketSaleOrder(d).then((r) => {
                this.$store.commit("set_printUrl", r.msg);
                // if (r.url != '') {
                // 	this.printUrl = r.url;
                // 	setTimeout(() => {
                // 		this.printUrl = '';
                // 	}, 1000)
                // }
              });
              // util.print(d).then(r => {
              // 	if (r.url != '') {
              // 		this.printUrl = r.url;
              // 		this.$store.commit("set_printUrl",this.printUrl)
              // 	}

              // })
            }
          });
      } else if (this.type == "recharge" || this.type == "yajin") {
        this.$http
          .get("/api/Recharge/OrderRechargeReceipt", {
            orderNumber: this.orderId,
          })
          .then((res) => {
            if (res.code == 0) {
              let d = res.data;
              printJs.printTicketSaleOrder(d).then((r) => {
                this.$store.commit("set_printUrl", r.msg);
                // if (r.url != '') {
                // 	this.printUrl = r.url;
                // 	setTimeout(() => {
                // 		this.printUrl = '';
                // 	}, 1000)
                // }
              });
              // util.print(d).then(r => {
              // 	if (r.url != '') {
              // 		this.printUrl = r.url;
              // 		this.$store.commit("set_printUrl",this.printUrl)
              // 	}
              // })
            }
          });
      }
    },
    // 京东支付
    jingdongPay() {
      if (this.jingdong == "") {
        this.jingdongState = 0;
        this.jingdongDisabled = true;
      }
    },
    // 拉卡拉支付
    lakalaPay() {
      if (this.lakala == "") {
        this.lakalaState = 0;
        this.lakalaDisabled = true;
      }
    },
    submit(state) {
      if (this.order.order_type_id === 8||this.youhui>0) {
        if(this.beizhu==''){
        this.$message({
						type: 'info',
						message: '请填写备注'
					});
          return;
       }
      }
      // this.isDisabled=false;
      this.isShow = false;
      let loading = this.$loading();
      if (state == "close") {
        loading.close();
        this.$emit("submit", "close");
      } else if (state == "scan") {
        loading.close();
        // if (this.giftCard) {
        //   this.$message({
        //     message: "使用礼品卡后，不可再使用扫码支付",
        //     type: "error",
        //   });
        //   return;
        // }
        // 礼品卡
        let gift_card_list = [];
        if (this.giftCard && this.type !== "changePayInfo") {
          let total = 0;
          for (let i = 0; i < this.giftCardTableData.length; i++) {
            total = this.$public.jia(total, this.giftCardTableData[i].useNum);
            if (this.giftCardTableData[i].useNum > 0) {
              gift_card_list.push({
                card_no: this.giftCardTableData[i].card_number,
                card_type: this.giftCardTableData[i].card_type.value,
                money: this.giftCardTableData[i].useNum,
              });
            }
          }
          if (total !== Number(this.giftCard)) {
            this.$message({
              message: "礼品卡余额不足，请添加其它支付方式",
              type: "error",
            });
            loading.close();
            return;
          }
        }
        let pay_list = [];
        // 现金
        if (this.xianjin) {
          pay_list.push({
            pay_type: 0,
            money: Number(this.xianjin) + -Number(this.zhaoling),
          });
        }
        // 余额
        if (this.mustYue > (this.yue || 0)) {
          this.$message({
            message: "支付此订单需至少使用 " + this.mustYue + "元 余额",
            type: "error",
          });
          loading.close();
          return;
        }
        if (this.yue) {
          if (
            Number(this.memberDetail.userBalance) < Number(this.yue) &&
            this.type !== "exchangeGoods" &&
            this.type !== "returnGoods"
          ) {
            // 退换货不判断余额
            this.$message({
              message: "余额不足",
              type: "fail",
            });
            loading.close();
            return;
          } else {
            pay_list.push({
              pay_type: 7,
              money: Number(this.yue),
            });
          }
        }
        // 微信
        if (this.weixin > 0) {
          pay_list.push({
            pay_type: 4,
            money: Number(this.weixin),
          });
        }
        // 支付宝
        if (this.zhifubao > 0) {
          pay_list.push({
            pay_type: 3,
            money: Number(this.zhifubao),
          });
        }
        // 美团
        if (this.meituan > 0) {
          pay_list.push({
            pay_type: 11,
            money: Number(this.meituan),
          });
        }
        // 优惠
        if (this.youhui > 0) {
          pay_list.push({
            pay_type: 12,
            money: Number(this.youhui),
          });
        }
        // 礼品卡
        if (this.giftCard > 0) {
          pay_list.push({
            pay_type: 16,
            money: Number(this.giftCard),
          });
        }
        // 京东聚合
        if (this.jingdong > 0) {
          pay_list.push({
            pay_type: 13,
            money: Number(this.jingdong),
          });
        }
        // // 嘉联
        // if (this.jialian > 0) {
        //   pay_list.push({
        //     pay_type: 15,
        //     money: Number(this.jialian),
        //   });
        // }
        // 拉卡拉
        if (this.lakala > 0) {
          pay_list.push({
            pay_type: 17,
            money: Number(this.lakala),
          });
        }
        // pos
        if (this.pos > 0) {
          pay_list.push({
            pay_type: 5,
            money: Number(this.pos),
          });
        }
        // 押金
        if (this.deposit > 0) {
          pay_list.push({
            pay_type: 10,
            money: Number(this.deposit),
          });
        }
        // 定金
        if (this.dingjin > 0) {
          pay_list.push({
            pay_type: 14,
            money: Number(this.dingjin),
          });
        }
        // 找零
        // if (this.zhaoling > 0) {
        //   pay_list.push({
        //     "pay_type": 6,
        //     "money": -Number(this.zhaoling)
        //   })
        // }
        // 支付金额为0时，传现金0
        if (this.order.total_price === 0) {
          pay_list.push({
            pay_type: 0,
            money: 0,
          });
        }

        this.pay_Info = {
          pay_remark: this.beizhu,
          gift_card_list: gift_card_list,
          pay_list: pay_list,
        };
        this.pay_type = 1;
        // console.log('京东扫码');
        this.dialogScanState = true;
      } else if (state == "lakalaScan") {
        loading.close();
        // if (this.giftCard) {
        //   this.$message({
        //     message: "使用礼品卡后，不可再使用扫码支付",
        //     type: "error",
        //   });
        //   return;
        // }
        // 礼品卡
        let gift_card_list = [];
        if (this.giftCard && this.type !== "changePayInfo") {
          let total = 0;
          for (let i = 0; i < this.giftCardTableData.length; i++) {
            total = this.$public.jia(total, this.giftCardTableData[i].useNum);
            if (this.giftCardTableData[i].useNum > 0) {
              gift_card_list.push({
                card_no: this.giftCardTableData[i].card_number,
                card_type: this.giftCardTableData[i].card_type.value,
                money: this.giftCardTableData[i].useNum,
              });
            }
          }
          if (total !== Number(this.giftCard)) {
            this.$message({
              message: "礼品卡余额不足，请添加其它支付方式",
              type: "error",
            });
            loading.close();
            return;
          }
        }
        let pay_list = [];
        // 现金
        if (this.xianjin) {
          pay_list.push({
            pay_type: 0,
            money: Number(this.xianjin) + -Number(this.zhaoling),
          });
        }
        // 余额
        if (this.mustYue > (this.yue || 0)) {
          this.$message({
            message: "支付此订单需至少使用 " + this.mustYue + "元 余额",
            type: "error",
          });
          loading.close();
          return;
        }
        if (this.yue) {
          if (
            Number(this.memberDetail.userBalance) < Number(this.yue) &&
            this.type !== "exchangeGoods" &&
            this.type !== "returnGoods"
          ) {
            // 退换货不判断余额
            this.$message({
              message: "余额不足",
              type: "fail",
            });
            loading.close();
            return;
          } else {
            pay_list.push({
              pay_type: 7,
              money: Number(this.yue),
            });
          }
        }
        // 微信
        if (this.weixin > 0) {
          pay_list.push({
            pay_type: 4,
            money: Number(this.weixin),
          });
        }
        // 支付宝
        if (this.zhifubao > 0) {
          pay_list.push({
            pay_type: 3,
            money: Number(this.zhifubao),
          });
        }
        // 美团
        if (this.meituan > 0) {
          pay_list.push({
            pay_type: 11,
            money: Number(this.meituan),
          });
        }
        // 优惠
        if (this.youhui > 0) {
          pay_list.push({
            pay_type: 12,
            money: Number(this.youhui),
          });
        }
        // 礼品卡
        if (this.giftCard > 0) {
          pay_list.push({
            pay_type: 16,
            money: Number(this.giftCard),
          });
        }
        // 京东聚合
        if (this.jingdong > 0) {
          pay_list.push({
            pay_type: 13,
            money: Number(this.jingdong),
          });
        }
        // // 嘉联
        // if (this.jialian > 0) {
        //   pay_list.push({
        //     pay_type: 15,
        //     money: Number(this.jialian),
        //   });
        // }
        // 拉卡拉
        if (this.lakala > 0) {
          pay_list.push({
            pay_type: 17,
            money: Number(this.lakala),
          });
        }
        // pos
        if (this.pos > 0) {
          pay_list.push({
            pay_type: 5,
            money: Number(this.pos),
          });
        }
        // 押金
        if (this.deposit > 0) {
          pay_list.push({
            pay_type: 10,
            money: Number(this.deposit),
          });
        }
        // 定金
        if (this.dingjin > 0) {
          pay_list.push({
            pay_type: 14,
            money: Number(this.dingjin),
          });
        }
        // 找零
        // if (this.zhaoling > 0) {
        //   pay_list.push({
        //     "pay_type": 6,
        //     "money": -Number(this.zhaoling)
        //   })
        // }
        // 支付金额为0时，传现金0
        if (this.order.total_price === 0) {
          pay_list.push({
            pay_type: 0,
            money: 0,
          });
        }
        this.pay_Info = {
          pay_remark: this.beizhu,
          gift_card_list: gift_card_list,
          pay_list: pay_list,
        };
        this.pay_type = 2;
        this.dialogScanState = true;
      } else if (state == "jialianScan") {
        loading.close();
        if (this.giftCard) {
          this.$message({
            message: "使用礼品卡后，不可再使用扫码支付",
            type: "error",
          });
          return;
        }
      } else {
        if (this.allMoney < this.order.total_price) {
          // 总价小于订单金额
          if (this.allMoney == 0) {
            this.$message({
              message: "请输入金额",
              type: "error",
            });
            loading.close();
            return;
          }
          this.$message({
            message: "输入金额不足",
            type: "error",
          });
          loading.close();
          return;
        }
        // 礼品卡
        let gift_card_list = [];
        if (this.giftCard && this.type !== "changePayInfo") {
          let total = 0;
          for (let i = 0; i < this.giftCardTableData.length; i++) {
            total = this.$public.jia(total, this.giftCardTableData[i].useNum);
            if (this.giftCardTableData[i].useNum > 0) {
              gift_card_list.push({
                card_no: this.giftCardTableData[i].card_number,
                card_type: this.giftCardTableData[i].card_type.value,
                money: this.giftCardTableData[i].useNum,
              });
            }
          }
          if (total !== Number(this.giftCard)) {
            this.$message({
              message: "礼品卡余额不足，请添加其它支付方式",
              type: "error",
            });
            loading.close();
            return;
          }
        }
        let pay_list = [];
        // 现金
        if (this.xianjin) {
          pay_list.push({
            pay_type: 0,
            money: Number(this.xianjin) + -Number(this.zhaoling),
          });
        }
        // 余额
        if (this.mustYue > (this.yue || 0)) {
          this.$message({
            message: "支付此订单需至少使用 " + this.mustYue + "元 余额",
            type: "error",
          });
          loading.close();
          return;
        }
        if (this.yue) {
          if (
            Number(this.memberDetail.userBalance) < Number(this.yue) &&
            this.type !== "exchangeGoods" &&
            this.type !== "returnGoods"
          ) {
            // 退换货不判断余额
            this.$message({
              message: "余额不足",
              type: "fail",
            });
            loading.close();
            return;
          } else {
            pay_list.push({
              pay_type: 7,
              money: Number(this.yue),
            });
          }
        }
        // 微信
        if (this.weixin > 0) {
          pay_list.push({
            pay_type: 4,
            money: Number(this.weixin),
          });
        }
        // 支付宝
        if (this.zhifubao > 0) {
          pay_list.push({
            pay_type: 3,
            money: Number(this.zhifubao),
          });
        }
        // 美团
        if (this.meituan > 0) {
          pay_list.push({
            pay_type: 11,
            money: Number(this.meituan),
          });
        }
        // 优惠
        if (this.youhui > 0) {
          pay_list.push({
            pay_type: 12,
            money: Number(this.youhui),
          });
        }
        // 礼品卡
        if (this.giftCard > 0) {
          pay_list.push({
            pay_type: 16,
            money: Number(this.giftCard),
          });
        }
        // 京东聚合
        if (this.jingdong > 0) {
          pay_list.push({
            pay_type: 13,
            money: Number(this.jingdong),
          });
        }
        // // 嘉联
        // if (this.jialian > 0) {
        //   pay_list.push({
        //     pay_type: 15,
        //     money: Number(this.jialian),
        //   });
        // }
        // 拉卡拉
        if (this.lakala > 0) {
          pay_list.push({
            pay_type: 17,
            money: Number(this.lakala),
          });
        }
        // pos
        if (this.pos > 0) {
          pay_list.push({
            pay_type: 5,
            money: Number(this.pos),
          });
        }
        // 押金
        if (this.deposit > 0) {
          pay_list.push({
            pay_type: 10,
            money: Number(this.deposit),
          });
        }
        // 定金
        if (this.dingjin > 0) {
          pay_list.push({
            pay_type: 14,
            money: Number(this.dingjin),
          });
        }
        // 找零
        // if (this.zhaoling > 0) {
        //   pay_list.push({
        //     pay_type: 6,
        //     money: -Number(this.zhaoling),
        //   });
        // }
        // 支付金额为0时，传现金0
        if (this.order.total_price === 0) {
          pay_list.push({
            pay_type: 0,
            money: 0,
          });
        }
        // 活体结算
        if (this.type == "order" || this.type == "mergeOrder") {
   
    
              let params = {
                order_id: this.order._id, // 订单记录id
                order_no: this.order.no, // 订单号
                pay_Info: {
                  pay_remark: this.beizhu,
                  payment_no: "", // 支付流水号
                  pay_list: pay_list, //支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 6 找零 7 余额 8 赠额 9 积分
                  gift_card_list: gift_card_list,
                },
              };
              let loading = this.$loading();
              this.$http.post("/api/Order/PayOrder", params).then((res) => {
                loading.close();
                if (res.code == 0) {
                  // console.log("结算", res);
                  this.$emit("submit", "success");
                  this.$store.dispatch("mendian/get_unPayOrderList");
                  if (this.type == "order") {
                    this.getInvoice();
                  }
                } else {
                  this.$emit("submit", "fail");
                }
              });
            
        } else if (this.type == "tailMoney"||this.type == "tailMoneyMergeOrder") {
          // 付尾款
          console.log(this.type,'type');
          let params = {
            order_id: this.order._id, // 订单记录id
            order_no: this.order.no, // 订单号
            pay_Info: {
              pay_remark: this.beizhu,
              payment_no: "", // 支付流水号
              pay_list: pay_list, //支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 6 找零 7 余额 8 赠额 9 积分
              gift_card_list: gift_card_list,
            },
          };
          let loading = this.$loading();
          this.$http.post("/api/Order/PayOrder", params).then((res) => {
            loading.close();
            if (res.code == 0) {
              this.$emit("submit", "success");
              this.$store.dispatch("mendian/get_unPayOrderList");
              if (this.type == "order") {
                this.getInvoice();
              }
              if (Number(this.dingjin) > Number(this.order.total_price)) {
                this.$nextTick(() => {
                  this.$message({
                    message: "所选订金超出活体金额，请及时退回超出金额给客户",
                    type: "warning",
                  });
                  return;
                });
              }
            } else {
              this.$emit("submit", "fail");
            }
          });
        } else if (this.type == "changePayInfo") {
          let params = {
            order_id: this.order._id, // 订单记录id
            order_no: this.order.no, // 订单号
            pay_Info: {
              pay_remark: this.beizhu,
              payment_no: "", // 支付流水号
              pay_list: pay_list, //支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
              // gift_card_list 不传此参数 ，就是不修改礼品卡支付信息
            },
          };
          let loading = this.$loading();
          //修改订单支付方式
          this.$http
            .post(
              process.env.VUE_APP_Url_order + "/api/OffLineOrder/UpdatePayInfo",
              params
            )
            .then((res) => {
              loading.close();
              if (res.code == 0) {
                this.$emit("submit", "success");
              } else {
                this.$emit("submit", "fail");
              }
            });
        } else if (this.type == "recharge" || this.type == "yajin") {
          let params = {
            order_id: this.order._id, // 订单记录id
            order_no: this.order.no, // 订单号
            pay_Info: {
              pay_remark: this.beizhu,
              payment_no: "", // 支付流水号
              pay_list: pay_list, //支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
            },
          };
          let loading = this.$loading();
          // 充值订单支付
          this.$http.post("/api/Recharge/PayOrder", params).then((res) => {
            loading.close();
            if (res.code == 0) {
              console.log(res, "充值");
              this.$emit("submit", "success");
              this.$store.dispatch("mendian/get_unPayOrderList");
              this.getInvoice();
            } else {
              // this.$emit("submit", "fail");
            }
          });
        } else if (this.type == "returnGoods") {
          let params = {
            order_return_id: this.order.no, // 订单记录id
            // order_no:this.order.no,  // 订单号
            pay_Info: {
              pay_remark: this.beizhu,
              payment_no: "", // 支付流水号
              pay_list: pay_list, //支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
            },
          };
          let loading = this.$loading();
          //更改退款单的退款方式
          this.$http
            .post("/api/ReturnOrder/ReturnPayWay", params)
            .then((res) => {
              loading.close();
              if (res.code == 0) {
                this.$emit("submit", "success");
                this.$nextTick(() => {
                  this.$message({
                    message: "退款申请已提交成功, 请等待财务审核",
                    type: "success",
                  });
                });
                // this.getInvoice(); // 退货无发票
              } else {
                this.$emit("submit", "fail");
              }
            });
        } else if (this.type == "exchangeGoods") {
              let params = {
                order_id: this.order._id, // 订单记录id
                order_no: this.order.no, // 订单号
                pay_Info: {
                  pay_remark: this.beizhu,
                  payment_no: "", // 支付流水号
                  pay_list: pay_list, //支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
                },
              };
              let loading = this.$loading();
              this.$http
                .post("/api/ReturnOrder/ReplacePay", params)
                .then((res) => {
                  loading.close();
                  if (res.code == 0) {
                    this.$emit("submit", "success");
                    // this.getInvoice();  // 换货无发票
                  } else {
                    this.$emit("submit", "fail");
                  }
                });
            
        }
      }
      if (this.xianjin == 0 && this.zhaoling > 0) {
        this.$message({
          message: "请核对支付方式",
          type: "error",
        });
        return;
      }
      if (
        this.allMoney - Number(this.zhaoling || 0) !==
        this.order.total_price
      ) {
        this.$message({
          message: "请核对支付金额",
          type: "error",
        });
        return;
      }
    },
    // // 获取用户信息
    // getMustYue() {
    //   let params = {
    //     id: this.order.user_info.user_id,
    //   };
    //   this.$http.get(process.env.VUE_APP_Url_member+"/api/middleware/Member/Single", params).then((res) => {
    //     if (res.code == 0) {
    //       this.memberDetail = res.data;
    //       console.log(this.memberDetail,'this.memberDetail');
    //       if (this.type == "returnGoods" || this.type == "exchangeGoods") {
    //         console.log("退换货");
    //       } else if (
    //         this.type !== "returnGoods" &&
    //         this.type !== "exchangeGoods" &&
    //         this.type !== "recharge" &&
    //         this.type !== "yajin"
    //       ) {
    //         this.getMustYue();
    //       } else {
    //         this.getMustYue();
    //       }
    //     }
    //   });
    // },
    // 礼品卡
    getGiftCardDetail() {
      let code = this.scanningCode.toString().trim();
      for (let i = 0; i < this.giftCardTableData.length; i++) {
        if (code === this.giftCardTableData[i].card_number) {
          this.$message({
            message: "该礼品卡已添加",
            type: "error",
          });
          return;
        }
      }
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url_member + "/api/GiftCard/single", {
          cardNumber: code,
        })
        .then((res) => {
          loading.close();
          if (res.code === 0) {
            if (this.$public.isNull(res.data)) {
              this.$message({
                message: "未获取到礼品卡信息",
                type: "error",
              });
              return;
            }
            if (this.type === "tailMoney"||this.type == "tailMoneyMergeOrder") {
              if (res.data.card_type.value !== "2") {
                this.$message({
                  message: "该订单只能使用活体卡",
                  type: "error",
                });
                return;
              }
            }
            if (this.type == "order" || this.type == "mergeOrder") {
              if (this.order.order_type_id === 8) {
                if (res.data.card_type.value !== "2") {
                  this.$message({
                    message: "该订单只能使用活体卡",
                    type: "error",
                  });
                  return;
                }
              } else {
                if (res.data.card_type.value !== "1") {
                  this.$message({
                    message: "该订单只能使用现金卡",
                    type: "error",
                  });
                  return;
                }
              }
            }
            if (!this.$public.isNull(res.data.bind_info)) {
              if (res.data.bind_info.user_id !== this.order.user_info.user_id) {
                this.$message({
                  message:
                    "不可使用，因为该卡已被其它账户（" +
                    res.data.bind_info.user_name +
                    "）绑定。",
                  type: "error",
                });
                return;
              }
            }
            res.data.useNum = 0;
            this.giftCardTableData.push(res.data);
            this.giftCardTableData.sort((a, b) => {
              return a.surplus_money - b.surplus_money;
            });
            this.calcGiftCardNum();
          }
        });
      this.$nextTick(() => {
        this.scanningCode = "";
      });
    },
    closeGiftCard(i) {
      this.giftCardTableData.splice(i, 1);
      this.calcGiftCardNum();
    },
    calcGiftCardNum() {
      if (this.giftCardNumMax < this.giftCard) {
        this.$message({
          message: "礼品卡最多只能使用" + this.giftCardNumMax + "元",
          type: "error",
        });
        this.giftCard = this.giftCardNumMax;
      }
      let total = 0;
      for (let i = 0; i < this.giftCardTableData.length; i++) {
        total = this.$public.jia(
          total,
          this.giftCardTableData[i].surplus_money
        );
        if (this.giftCard > total) {
          this.giftCardTableData[i].useNum =
            this.giftCardTableData[i].surplus_money;
        } else {
          this.giftCardTableData[i].useNum = this.$public.jian(
            this.giftCardTableData[i].surplus_money,
            this.$public.jian(total, this.giftCard)
          );
        }
      }
    },
    getGiftCardNumMax() {
      if (
        this.type === "order" ||
        this.type == "changePayInfo" ||
        this.type == "tailMoney" ||
        this.type === "mergeOrder"||this.type == "tailMoneyMergeOrder"
      ) {
        let params = {
          order_no: this.orderId,
        };
        let loading = this.$loading();
        this.$http
          .get(
            process.env.VUE_APP_Url_order +
              "/api/OffLineOrder/GetGiftCardMoneyVerify",
            params
          )
          .then((res) => {
            loading.close();
            if (res.code === 0) {
              if (this.order.order_type_id === 8) {
                this.giftCardNumMax = res.data.living_money;
              } else {
                this.giftCardNumMax = res.data.money;
              }
            }
          });
      } else {
        this.giftCardNumMax = 0;
      }
    },
    // 获取订单详情
    getOrderDetail() {
      if (
        this.type == "order" ||
        this.type == "changePayInfo" ||
        this.type == "tailMoney"
      ) {
        let params = {
          orderid: this.orderId,
        };
        this.$http.get("/api/Order/GetOrder", params).then((res) => {
          if (res.code == 0) {
            this.order = res.data;
            this.getGiftCardNumMax();
            let table = this.order.order_item_list;
            let table2 = [];
            for (let i = 0; i < table.length; i++) {
              let one = {
                goodsId: table[i].goods_id, // 销售对象id
                goodsName: table[i].goods_name, // 销售对象名字
                goodsType: table[i].goods_type, // 1:商品；2:服务；3:套餐；
                skus: table[i].skus_id,
                skuValue: table[i].sku_value,
                unit: table[i].unit,
                originalPrice: table[i].original_price,
                price: table[i].price,
                num: parseInt(table[i].num),
                totalMoney: this.$public.toDoubleFixed2(
                  Number(table[i].price) * Number(table[i].num)
                ),
                goodsList: [],
              };
              table2.push(one);
            }
            this.o.init(table2);
            this.getMustYue();
            if (this.type === "tailMoney") {
              let params = {
                orderNos: res.data.other_param,
                filter: true, // true:过滤   false:不过滤
              };
              this.$http
                .get("/api/Order/GetOrderListByOrderNos", params)
                .then((res) => {
                  if (res.code === 0) {
                    for (let i = 0; i < res.data.length; i++) {
                      this.dingjin = this.$public.jia(
                        this.dingjin,
                        res.data[i].total_price
                      );
                    }
                  }
                });
            }
            if (this.type == "changePayInfo" && this.order.pay_info) {
              let payList = this.order.pay_info.pay_list;
              for (let i = 0; i < payList.length; i++) {
                if (payList[i].pay_type === 16) {
                  this.giftCard = payList[i].money;
                }
              }
            }
          }
        });
      } else if (this.type == "recharge" || this.type == "yajin") {
        let params = {
          orderid: this.orderId,
        };
        //获取充值详情
        this.$http.get("/api/recharge/GetRecharge", params).then((res) => {
          if (res.code == 0) {
            this.order = res.data;
            this.order.total_price = res.data.price;
            this.getMustYue();
          }
        });
      } else if (this.type == "returnGoods") {
        let params = {
          orderNumber: this.orderId,
        };
        //获取退换货详情
        this.$http.get("/api/ReturnOrder/Detail", params).then((res) => {
          if (res.code == 0) {
            this.order = res.data;
            this.order.total_price = res.data.total_price;
            this.getMustYue();
          }
        });
        // this.$http.get('/api/ReturnOrder/Money', params).then(res => {
        // 	if (res.code == 0) {
        // 		let payList = res.data;
        // 		//支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 6 找零 7 余额 8 赠额 9 积分 13京东聚合
        // 		for(let i=0;i<payList.length;i++){
        // 			if(payList[i].pay_type==0){
        // 				this.xianjin = payList[i].money;
        // 			}else if(payList[i].pay_type==3){
        // 				this.zhifubao = payList[i].money;
        // 			}if(payList[i].pay_type==11){
        // 				this.meituan = payList[i].money;
        // 			}else if(payList[i].pay_type==12){
        // 				this.youhui = payList[i].money;
        // 			}else if(payList[i].pay_type==13){
        // 				this.jingdong = payList[i].money;
        // 			}else if(payList[i].pay_type==4){
        // 				this.weixin = payList[i].money;
        // 			}else if(payList[i].pay_type==5){
        // 				this.pos = payList[i].money;
        // 			}else if(payList[i].pay_type==6){
        // 				this.zhaoling = payList[i].money;
        // 			}else if(payList[i].pay_type==7){
        // 				this.yue = payList[i].money;
        // 			}else if(payList[i].pay_type==10){
        // 				this.deposit = payList[i].money;
        // 			}
        // 		}
        // 	}
        // })
      } else if (this.type == "exchangeGoods") {
        let params = {
          orderNumber: this.orderId,
        };
        this.$http.get("/api/ReturnOrder/Detail", params).then((res) => {
          if (res.code == 0) {
            this.order = res.data;
            let table = this.order.replace_item_list;
            let table2 = [];
            for (let i = 0; i < table.length; i++) {
              let one = {
                goodsId: table[i].goods_id, // 销售对象id
                goodsName: table[i].goods_name, // 销售对象名字
                goodsType: table[i].goods_type, // 1:商品；2:服务；3:套餐；
                skus: table[i].skus_id,
                skuValue: table[i].sku_value,
                unit: table[i].unit,
                originalPrice: table[i].original_price,
                price: table[i].price,
                num: parseInt(table[i].num),
                totalMoney: this.$public.toDoubleFixed2(
                  Number(table[i].price) * Number(table[i].num)
                ),
                goodsList: [],
              };
              table2.push(one);
            }
            this.o.init(table2);
            this.order.total_price = res.data.total_price;
            this.getMustYue();
          }
        });
      } else if (this.type === "mergeOrder"||this.type == "tailMoneyMergeOrder") {
        let params = {
          mergeOrderNo: this.orderId,
        };
        let loading = this.$loading();
        //获取合并订单详情
        this.$http.get("/api/Order/GetMergeOrder", params).then((res) => {
          loading.close();
          if (res.code == 0) {
            let order = res.data;
            let table2 = [];
            let total_price = 0;
            for (let a = 0; a < order.length; a++) {
              let table = order[a].order_item_list;
              total_price = this.$public.jia(total_price, order[a].total_price);
              for (let i = 0; i < table.length; i++) {
                let one = {
                  goodsId: table[i].goods_id, //销售对象id
                  goodsName: table[i].goods_name, // 销售对象名字
                  goodsType: table[i].goods_type, // 1:商品；2:服务；3:套餐；
                  skus: table[i].skus_id,
                  skuValue: table[i].sku_value,
                  unit: table[i].unit,
                  originalPrice: table[i].original_price,
                  price: table[i].price,
                  num: parseInt(table[i].num),
                  totalMoney: this.$public.toDoubleFixed2(
                    Number(table[i].price) * Number(table[i].num)
                  ),
                  goodsList: [],
                };
                table2.push(one);
              }
              if (this.type == "tailMoneyMergeOrder"&&order[a].order_type_id==8&&order[a].other_param) {
                console.log(order[a].order_type_id,'order[a].order_type_id');
              let params = {
                orderNos: order[a].other_param,
                filter: true, // true:过滤   false:不过滤
              };
              this.$http
                .get("/api/Order/GetOrderListByOrderNos", params)
                .then((res) => {
                  if (res.code === 0) {
                    for (let i = 0; i < res.data.length; i++) {
                      this.dingjin += this.$public.jia(
                        this.dingjin,
                        res.data[i].total_price
                      );
                    }
                    console.log(this.dingjin,'dingjin');
                  }
                });
            }
            }
            this.o.init(table2);
            // this.getDeposit();
            this.order = {};
            this.order._id = "";
            this.order.no = this.orderId;
            this.order.total_price = total_price;
            this.order.user_info = {};
            this.order.user_info.user_id = order[0].user_info.user_id;
            this.getGiftCardNumMax();
            this.getMustYue();
            
          }
        });
      }
    },
    // 获取必须使用的余额金额
    getMustYue() {
      if (this.canYue === false) {
        return;
      }
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_apiHost + "api/Order/OrderLimitPayMoney", {
          orderNo: this.orderId,
        })
        .then((res) => {
          loading.close();
          if (res.code === 0) {
            console.log(res.data,'必须使用的余额');
            this.memberDetail=res.data
            this.mustYue = Number(res.data.limitYue);
            if (this.canYue === true && this.mustYue > 0) {
              if (this.mustYue <= this.memberDetail.userBalance) {
                // this.yue = this.mustYue;
                console.log(this.mustYue);
              } else {
                this.$message({
                  message:
                    "支付此订单需至少使用 " +
                    this.mustYue +
                    "元 余额，账户余额不足，请前往充值！",
                  type: "error",
                });
                this.yue = this.memberDetail.userBalance;
                return;
              }
            }
            this.meituan = res.data.limitThird;
            this.isShow = true;
            // this.isDisabled=true;
            if (this.canThird === true && this.mustThird > 0) {
              this.meituan = this.mustThird;
              console.log("第三方", this.meituan);
              return;
            }

          }
        });
    },

    submitScan(str) {
      this.dialogScanState = false;
      if (str === "success") {
        this.$emit("submit", "success");
        this.getInvoice();
      }
    },
    submitJialianScan(str) {
      this.dialogScanJialianState = false;
      if (str === "success") {
        this.$emit("submit", "success");
        this.getInvoice();
      }
    },
    // 聚焦
    focusXianjin() {
      if (this.xianjin == "") {
        this.xianjin = this.needPay;
      }
    },
    focusYue() {
      if (!this.yue) {
        if (this.memberDetail.userBalance < this.needPay) {
          this.yue = this.memberDetail.userBalance;
        } else {
          this.yue = this.needPay;
        }
      }
    },
    focusWeixin() {
      if (this.weixin == "") {
        this.weixin = this.needPay;
      }
    },
    focusZhifubao() {
      if (this.zhifubao == "") {
        this.zhifubao = this.needPay;
      }
    },
    focusMeituan() {
      if (this.meituan == "") {
        this.meituan = this.needPay;
      }
    },
    focusYouhui() {
      if (this.youhui == "") {
        this.youhui = this.needPay;
      }
    },
    focusGiftCard() {
      if (this.giftCard == "") {
        if (this.giftCardNumMax < this.needPay) {
          this.giftCard = this.giftCardNumMax;
        } else {
          this.giftCard = this.needPay;
        }
        this.calcGiftCardNum();
      }
      this.hasGiftCard = true;
    },

    focusDeposit() {
      if (!this.deposit) {
        if (this.memberDetail.userDeposit < this.needPay) {
          this.deposit = this.memberDetail.userDeposit;
        } else {
          this.deposit = this.needPay;
        }
      }
    },
    focusJingdong() {
      if (this.jingdong == "") {
        this.jingdong = this.needPay;
      }
      if (this.jingdong > 0) {
        this.jingdongState = 1;
        this.jingdongDisabled = false;
        this.lakala == "";
      }
    },
    focusLakala() {
      if (this.lakala == "") {
        this.lakala = this.needPay;
      }
      if (this.lakala > 0) {
        this.lakalaState = 1;
        this.lakalaDisabled = false;
        this.jingdong == "";
      }
    },
    // focusJialian() {
    //   if (this.jialian == "") {
    //     this.jialian = this.needPay;
    //   }
    // },
    focusPos() {
      if (this.pos == "") {
        this.pos = this.needPay;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.comp {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }

  .titleLine {
    width: 100%;
    padding: 10px 0 18px;
    border-bottom: 1px solid #dfdfdf;

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
    }

    .total {
      color: #545454;
      font-size: 14px;
      margin: 0 0 0 20px;
      vertical-align: bottom;
      font-weight: 500;
    }

    .count {
      color: #545454;
      font-size: 14px;
      margin: 0 0 0 20px;
      vertical-align: bottom;
      font-weight: 500;
    }
  }

  .dialog {
    .content {
      padding: 20px 0 0;

      .line {
        display: flex;
        margin-bottom: 15px;
        font-size: 16px;

        .label {
          color: #1a1a1a;
          width: 110px;
          line-height: 38px;
          height: 38px;
          text-align: right;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }

        .input {
          width: 128px;
          height: 38px;

          ::v-deep .el-input__inner {
            height: 38px;
            line-height: 38px;
            border-radius: 0 4px 4px 0;
          }
        }

        .price {
          width: 128px;
          font-size: 20px;
          color: #e02020;
          line-height: 38px;
        }
      }
    }

    .btns {
      display: flex;
      justify-content: space-around;
      font-size: 20px;
      padding: 10px 0px 10px;

      .submit {
        // width: 96px;
        padding: 3px 5px;
        font-size: 14px;
        line-height: 30px;
        border-radius: 2px;
        text-align: center;
        background-color: #fdd000;
        color: #1a1a1a;
      }
      .active {
        background-color: #cccc;
        color: black;
        border: 0px;
      }
      .activeA {
        background-color: #1853a4;
        color: #ffffff;
        border: 0px;
      }
      .btn3 {
        width: 80px;
      }
    }

    .packet {
      color: #747474;
      font-size: 14px;
      text-align: center;
      margin-top: 10px;
    }
  }

  // 礼品卡
  .giftCardItem {
    width: 500px;
    box-shadow: 2px 2px 4px 4px #eee;
    border-radius: 6px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin: 20px 0;
    .giftCardItemLine {
      display: flex;
      justify-content: space-between;
      line-height: 40px;
    }
  }
}
</style>
